module.exports = __webpack_public_path__ + "assets/media/day25.7667d48e.mp3";